/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import ProgressionJudgement from '@linc-technologies/linced-common/enums/progression-judgement';

@classNames(
  'progress-chart-legend',
  'layout-row',
  'layout-align-center-center',
  'layout-wrap',
)
export default class ProgressChartLegend extends Component {
  ProgressionJudgement = ProgressionJudgement;
}
